import { Component, OnInit, Signal, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  DsButtonVariants,
  DsColors,
  DsModalService,
  DsModalVariant,
  DsTooltipPosition,
  IconScale,
  Icons,
} from '@levelaccess/design-system';

import { NavService } from '../../../../services/navigation/nav.service';
import { INavMenuItem, NavigationItem } from '../../../../services/navigation/nav-structure';
import { AccountSettingsModalComponent } from '../../../../pages/public/settings/account/modal/account-settings-modal.component';

@Component({
  selector: 'top-navbar-profile-dropdown',
  templateUrl: './top-navbar-profile-dropdown.component.html',
  styleUrls: ['./top-navbar-profile-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TopNavbarProfileDropdownComponent implements OnInit {
  readonly Icons: typeof Icons = Icons;
  readonly IconScale: typeof IconScale = IconScale;
  readonly DsColors: typeof DsColors = DsColors;
  readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;
  readonly NavigationItem: typeof NavigationItem = NavigationItem;

  menuItems$: Observable<INavMenuItem[]>;
  activeMenuItem$: Observable<INavMenuItem>;

  protected isVerticalNavigationEnabled: Signal<boolean> = toSignal(this.navService.isVerticalNavigationEnabled$, {
    initialValue: false,
  });

  constructor(
    private navService: NavService,
    private dsModalService: DsModalService,
  ) {}

  ngOnInit(): void {
    this.menuItems$ = this.navService.getProfileMenuItems$(() => this.openAccountSettingsModal());
    this.activeMenuItem$ = this.navService.activeTopLevelMenuItem$();
  }

  private openAccountSettingsModal(): void {
    this.dsModalService.open(AccountSettingsModalComponent, DsModalVariant.center);
  }
}
